import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { LoadingController } from '@ionic/angular';
import { Config } from 'src/app/app-constant';
import { HttpService } from 'src/app/service/http/http.service';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-show-import-data',
  templateUrl: './show-import-data.component.html',
  styleUrls: ['./show-import-data.component.scss'],
})
export class ShowImportDataComponent implements OnInit {
  gridData: {
    columnInfo: Array<{ label: string, propertyName: string, sortingName: string }>,
    columnData: Array<any>,
    totalCount: number,
    totalNoOfPages: number,
    currentPage: number
  } = {
      columnInfo: [], columnData: [], totalCount: 0, totalNoOfPages: 0, currentPage: 0
    };
  renderData: any[] = [];
  paginationUrl: any = '';
  //paginationUrl: any = this.config.getAllImportHistroy;
  isChangeDetected: boolean = false;
  currentPage: number = 0;
  selectedSizeToShowData: number = 25;
  searchString: any;
  id: any;
  colName: any;
  headerName: any;
  buttonColorName: any;
  moduleName: any;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ShowImportDataComponent>, private fb: FormBuilder, private dialog: MatDialog,
    private config: Config, private httpService: HttpService, private loadingController: LoadingController,
    private datePipe: DatePipe,) { }

  ngOnInit() {
    this.buttonColorName = sessionStorage.getItem('buttonColorName');

    this.colName = this.data?.colName;
    this.id = this.data?.id;
    this.headerName = this.colName;
    this.moduleName = this.data?.module
    if (this.colName == 'Total') {
      this.colName = null;
    }
    
    this.initilaizeColumn();
    if (this.moduleName == 'importemployee') {
      this.getimportHistroyData();
    }
    if (this.moduleName == 'importgoals') {
      this.getImportHistroyDataofGoalSetting();
    }
    if (this.moduleName == 'importDWM') {
      this.getImportHistoryDWM();
    }
    if(this.moduleName == 'competencyImport'){
      this.competencySearchImportHistoryInfo();
    }
  }
  initilaizeColumn() {
    this.gridData.columnInfo = [];
    if (this.moduleName == 'importemployee') {
      this.gridData.columnInfo.push({ label: 'Emp ID', propertyName: 'empID', sortingName: 'incidentNumber' });
      this.gridData.columnInfo.push({ label: 'First Name', propertyName: 'firstName', sortingName: 'firstName' });
      this.gridData.columnInfo.push({ label: 'Last Name', propertyName: 'lastName', sortingName: 'lastName' });
      this.gridData.columnInfo.push({ label: 'DOJ', propertyName: 'doj', sortingName: 'doj' });
      this.gridData.columnInfo.push({ label: 'Designation', propertyName: 'designation', sortingName: 'firstName' });
      this.gridData.columnInfo.push({ label: 'Department', propertyName: 'department', sortingName: 'firstName' });
      this.gridData.columnInfo.push({ label: 'Manager', propertyName: 'manager', sortingName: 'firstName' });
      if (this.colName == 'Skip') {
        this.gridData.columnInfo.push({ label: 'Reason', propertyName: 'reason', sortingName: 'message' });
      }
    }
    if (this.moduleName == 'importgoals') {
      this.gridData.columnInfo.push({ label: 'Emp ID', propertyName: 'empID', sortingName: 'incidentNumber' });
      this.gridData.columnInfo.push({ label: 'KRA', propertyName: 'kra', sortingName: 'kra' });
      this.gridData.columnInfo.push({ label: 'My KPI', propertyName: 'kpi', sortingName: 'myKpi' });
      this.gridData.columnInfo.push({ label: 'Lesser Is Better', propertyName: 'lesserIsBetter', sortingName: 'lesserIsBetter' });
      this.gridData.columnInfo.push({ label: 'UOM', propertyName: 'uom', sortingName: 'uom' });
      this.gridData.columnInfo.push({ label: 'Weightage', propertyName: 'weightage', sortingName: 'weightage' });
      if (this.colName == 'Skip') {
        this.gridData.columnInfo.push({ label: 'Reason', propertyName: 'reason', sortingName: 'message' });
      }
    }
    if (this.moduleName == 'importDWM') {
      this.gridData.columnInfo.push({ label: 'Date', propertyName: 'date', sortingName: 'date' });
      this.gridData.columnInfo.push({ label: 'Employee Code', propertyName: 'employeeCode', sortingName: 'employeeCode' });
      this.gridData.columnInfo.push({ label: 'First Name', propertyName: 'firstName', sortingName: 'firstName' });
      this.gridData.columnInfo.push({ label: 'Last Name', propertyName: 'lastName', sortingName: 'lastName' });
      this.gridData.columnInfo.push({ label: 'Actionable', propertyName: 'actionable', sortingName: 'actionable' });
      this.gridData.columnInfo.push({ label: 'Is This Fixed Task', propertyName: 'isThisFixedTask', sortingName: 'isThisFixedTask' });
      if (this.colName == 'Skip') {
        this.gridData.columnInfo.push({ label: 'Reason', propertyName: 'reason', sortingName: 'message' });
      }
    }
    if (this.moduleName == 'competencyImport') {
      this.gridData.columnInfo.push({ label: 'Function', propertyName: 'function', sortingName: 'date' });
      this.gridData.columnInfo.push({ label: 'Band/Grade', propertyName: 'band', sortingName: 'employeeCode' });
      this.gridData.columnInfo.push({ label: 'Competency', propertyName: 'competency', sortingName: 'firstName' });
      this.gridData.columnInfo.push({ label: 'Competency Defination', propertyName: 'competencyDefination', sortingName: 'lastName' });
      this.gridData.columnInfo.push({ label: 'WT', propertyName: 'wt', sortingName: 'isThisFixedTask' });
      if (this.colName == 'Skip') {
        this.gridData.columnInfo.push({ label: 'Reason', propertyName: 'reason', sortingName: 'message' });
      }
    }
  }
  getimportHistroyData() {
    const request = {
      "importHistoryId": this.id,
      "recordType": this.colName,
      "search": ""
    }
    this.httpService.callPostService(this.config.searchImportHistoryInfo, request).subscribe((data: any) => {
      this.currentPage = 0;
      this.gridData.totalNoOfPages = data.data?.totalPages;
      this.gridData.totalCount = data.data?.total;
      this.gridData.currentPage = data.data?.currentPageNumber;
      this.renderColumnData(data.data.history);
    });
  }

  renderColumnData(listData: any) {
    this.gridData.columnData = [];
    let cnt = this.gridData.currentPage * 25;
    if (this.colName == 'Skip') {
      for (let i = 0; i < listData?.length; i++) {
        if (this.moduleName == 'importemployee') {
          this.gridData.columnData.push({
            id: listData[i].id,
            empID: listData[i].employeeCode,
            firstName: listData[i].employeeFirstName,
            lastName: listData[i].employeeLastName,
            doj: this.datePipe.transform(listData[i].dateOfJoining, "yyyy-MM-dd"),
            designation: listData[i].designation,
            department: listData[i].department,
            manager: listData[i].reportingManagerName,
            reason: listData[i].message
          });
        }
        if (this.moduleName == 'importgoals') {
          this.gridData.columnData.push({
            id: listData[i].id,
            empID: listData[i].employeeCode,
            kra: listData[i].kra,
            kpi: listData[i].myKpi,
            lesserIsBetter: listData[i].lesserIsBetter,
            uom: listData[i].uom,
            weightage: listData[i].weightage,
            reason: listData[i].message
          });
        }
        if (this.moduleName == 'importDWM') {
          this.gridData.columnData.push({
            id: listData[i].id,
            date: this.datePipe.transform(listData[i].importHistory.createdAt, "dd-MM-yyyy"),
            employeeCode: listData[i].employeeCode,
            firstName: listData[i].employeeFirstName,
            lastName: listData[i].employeeLastName,
            actionable: listData[i].actionable,
            isThisFixedTask: listData[i].fixedTask,
            reason: listData[i].message
          });
        }
        if (this.moduleName == 'competencyImport') {
          this.gridData.columnData.push({
            id: listData[i].id,
            function: this.datePipe.transform(listData[i].importHistory.createdAt, "dd-MM-yyyy"),
            band: listData[i].employeeCode,
            competency: listData[i].employeeFirstName,
            competencyDefination: listData[i].employeeLastName,
            wt: listData[i].actionable,
            createdBy: listData[i].fixedTask,
            updatedBy: listData[i].message,
            reason: listData[i].message
          });
        }
      }
    } else {
      for (let i = 0; i < listData?.length; i++) {
        if (this.moduleName == 'importemployee') {
          this.gridData.columnData.push({
            id: listData[i].id,
            empID: listData[i].employeeCode,
            firstName: listData[i].employeeFirstName,
            lastName: listData[i].employeeLastName,
            doj: this.datePipe.transform(listData[i].dateOfJoining, "dd-MM-yyyy"),
            designation: listData[i].designation,
            department: listData[i].department,
            manager: listData[i].reportingManagerName,
          });
        }
        if (this.moduleName == 'importgoals') {
          this.gridData.columnData.push({
            id: listData[i].id,
            empID: listData[i].employeeCode,
            kra: listData[i].kra,
            kpi: listData[i].myKpi,
            lesserIsBetter: listData[i].lesserIsBetter,
            uom: listData[i].uom,
            weightage: listData[i].weightage,
          });
        }
        if (this.moduleName == 'importDWM') {
          this.gridData.columnData.push({
            id: listData[i].id,
            date: this.datePipe.transform(listData[i].importHistory.createdAt, "dd-MM-yyyy"),
            employeeCode: listData[i].employeeCode,
            firstName: listData[i].employeeFirstName,
            lastName: listData[i].employeeLastName,
            actionable: listData[i].actionable,
            isThisFixedTask: listData[i].fixedTask,
          });
        }
        if (this.moduleName == 'competencyImport') {
          this.gridData.columnData.push({
            id: listData[i].id,
            function: this.datePipe.transform(listData[i].importHistory.createdAt, "dd-MM-yyyy"),
            band: listData[i].employeeCode,
            competency: listData[i].employeeFirstName,
            competencyDefination: listData[i].employeeLastName,
            wt: listData[i].actionable,
            createdBy: listData[i].fixedTask,
            updatedBy: listData[i].message,
          });
        }
      }
    }
    this.isChangeDetected = !this.isChangeDetected;
    this.mapRenderData();
  }
  mapRenderData() {
    console.log(this.gridData.columnData)
    this.renderData = [];
    for (let i = 0; i < this.gridData.columnData.length; i++) {
      var output = Object.entries(this.gridData.columnData[i]).map(([key, value]) => ({ key, value }));
      this.renderData.push(output);
    }
  }
  pageNavigation(response: any) { }
  onSortAssending(data: any) { }
  onSortDesending(data: any) { }
  pageChange(data: any) { }
  downloadSkippedEmp() {
    const request = {
      "importHistoryId": this.id,
      "recordType": this.colName,
      "search": ""
    }
    if (this.moduleName == 'importemployee') {
      this.httpService.callPostService(this.config.downloadSkippedEmp, request).subscribe((data: any) => {
        saveAs(data?.fileUrl, "Skipped_Records.xlsx");
      });
    }
    if (this.moduleName == 'importgoals') {
      this.httpService.callPostService(this.config.downloadSkippedGoals, request).subscribe((data: any) => {
        saveAs(data?.fileUrl, "Skipped_Records.xlsx");
      });
    }
    if (this.moduleName == 'importDWM') {
      this.httpService.callPostService(this.config.downloadSkippedDwm, request).subscribe((data: any) => {
        saveAs(data?.fileUrl, "Skipped_Records.xlsx");
      });
    }
    if(this.moduleName == 'competencyImport'){
      this.httpService.callPostService(this.config.competencySkippedRecords, request).subscribe((data: any) => {
        saveAs(data?.data, "Skipped_Records.xlsx");
      });
    }

  }
  getImportHistroyDataofGoalSetting() {
    const request = {
      "importHistoryId": this.id,
      "recordType": this.colName,
      "search": ""
    }
    this.httpService.callPostService(this.config.getImportHistroyDataofGoalSetting, request).subscribe((data: any) => {
      this.currentPage = 0;
      this.gridData.totalNoOfPages = data.data?.totalPages;
      this.gridData.totalCount = data.data?.total;
      this.gridData.currentPage = data.data?.currentPageNumber;
      this.renderColumnData(data.data.history);
    });
  }

  getImportHistoryDWM() {
    const request = {
      "importHistoryId": this.id,
      "recordType": this.colName,
      "search": ""
    }
    this.httpService.callPostService(this.config.DWMSearchImportHistoryInfo, request).subscribe((data: any) => {
      this.currentPage = 0;
      this.gridData.totalNoOfPages = data.data?.totalPages;
      this.gridData.totalCount = data.data?.total;
      this.gridData.currentPage = data.data?.currentPageNumber;
      this.renderColumnData(data.data.history);
    });
  }
  competencyemployee:any=[]
  competencySearchImportHistoryInfo(){
    const request = {
      "importHistoryId": this.id,
      "recordType": this.colName,
      "search": ""
    }
    this.httpService.callPostService(this.config.competencySearchImportHistoryInfo, request).subscribe((data: any) => {
      this.currentPage = 0;
      this.gridData.totalNoOfPages = data.data?.totalPages;
      this.gridData.totalCount = data.data?.total;
      this.gridData.currentPage = data.data?.currentPageNumber;
      this.competencyemployee = data.data.data;
    });
  }
  getTotalWeight(item: any): number {
    return item.competencyMasterlist?.reduce((acc: number, comp: any) =>
      acc + (comp.weightageNo || 0), 0);
  }
}
